import { redBtn, cancelBtn, labelStyle, inputStyle, modalOverlay, modalBox, modalHeader, closeBtn } from '../../styles/adminStyles';

function CouponFormModal({ editingCoupon, couponForm, setCouponForm, users, categories, products, onSave, onClose, onDelete }) {
  return (
    <div style={modalOverlay}>
      <div style={{ ...modalBox, width: '600px' }}>
        <div style={modalHeader}>
          <h2 style={{ margin: 0, fontSize: '18px' }}>{editingCoupon ? 'Kuponu Düzenle' : 'Yeni Kupon / İndirim'}</h2>
          <button onClick={onClose} style={closeBtn}>×</button>
        </div>

        <div style={{ marginBottom: '20px', padding: '14px', backgroundColor: couponForm.isVisible ? '#E8F0EA' : '#f9f9f9', borderRadius: '8px', border: `1px solid ${couponForm.isVisible ? '#1F4A33' : '#eee'}` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontWeight: '600', fontSize: '14px', color: couponForm.isVisible ? '#1F4A33' : '#333' }}>
                {couponForm.isVisible ? '👁 Görünür Kupon' : '🔒 Gizli Kupon (Kod ile)'}
              </div>
              <div style={{ fontSize: '12px', color: '#111', marginTop: '3px' }}>
                {couponForm.isVisible ? 'Kullanıcılar "Kuponlarım" sayfasında bu kuponu görecek' : 'Kullanıcılar sadece kod girerek bu kuponu kullanabilir'}
              </div>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type="checkbox" checked={couponForm.isVisible} onChange={e => setCouponForm(p => ({ ...p, isVisible: e.target.checked }))} />
              <span style={{ fontSize: '13px', fontWeight: '600' }}>Görünür Yap</span>
            </label>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Kupon Kodu (boş bırakırsanız otomatik oluşturulur)</label>
            <input style={inputStyle} placeholder="Örn: HOSGELDIN20" value={couponForm.code} onChange={e => setCouponForm(p => ({ ...p, code: e.target.value.toUpperCase().replace(/\s/g, '') }))} />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Açıklama <span style={{ color: '#111', fontWeight: '400' }}>(kullanıcıya gösterilir)</span></label>
            <input style={inputStyle} placeholder="Örn: İlk siparişine özel %20 indirim!" value={couponForm.description} onChange={e => setCouponForm(p => ({ ...p, description: e.target.value }))} />
          </div>
          <div>
            <label style={labelStyle}>İndirim Türü *</label>
            <select style={inputStyle} value={couponForm.discountType} onChange={e => setCouponForm(p => ({ ...p, discountType: e.target.value }))}>
              <option value="fixed">Sabit Tutar (TL)</option>
              <option value="percent">Yüzde (%)</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>İndirim Değeri *</label>
            <input style={inputStyle} type="number" value={couponForm.discountValue} onChange={e => setCouponForm(p => ({ ...p, discountValue: e.target.value }))} />
          </div>
          <div>
            <label style={labelStyle}>Min. Sipariş (TL)</label>
            <input style={inputStyle} type="number" placeholder="0" value={couponForm.minOrderAmount} onChange={e => setCouponForm(p => ({ ...p, minOrderAmount: e.target.value }))} />
          </div>
          <div>
            <label style={labelStyle}>Kişi Başı Kullanım Limiti</label>
            <input style={inputStyle} type="number" placeholder="1" value={couponForm.usagePerUser} onChange={e => setCouponForm(p => ({ ...p, usagePerUser: e.target.value }))} />
            <div style={{ fontSize: '11px', color: '#111', marginTop: '4px' }}>0 = sınırsız, 1 = tek kullanım</div>
          </div>
          <div>
            <label style={labelStyle}>Toplam Kullanım Limiti</label>
            <input style={inputStyle} type="number" placeholder="Sınırsız" value={couponForm.usageLimit} onChange={e => setCouponForm(p => ({ ...p, usageLimit: e.target.value }))} />
          </div>
          <div>
            <label style={labelStyle}>Son Kullanım Tarihi</label>
            <input style={inputStyle} type="date" value={couponForm.expiresAt} onChange={e => setCouponForm(p => ({ ...p, expiresAt: e.target.value }))} />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Hedef Kitle</label>
            <select style={inputStyle} value={couponForm.targetType} onChange={e => setCouponForm(p => ({ ...p, targetType: e.target.value }))}>
              <option value="all">Herkese Açık</option>
              <option value="new_user">Yeni Kullanıcılar (İlk Sipariş)</option>
              <option value="user">Kişiye Özel</option>
              <option value="category">Kategoriye Özel</option>
              <option value="product">Ürüne Özel</option>
            </select>
          </div>
          {couponForm.targetType === 'user' && (
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Kullanıcı</label>
              <select style={inputStyle} value={couponForm.targetUserId} onChange={e => { const user = users.find(u => u.id === e.target.value); setCouponForm(p => ({ ...p, targetUserId: e.target.value, targetUserEmail: user?.email || '' })); }}>
                <option value="">Kullanıcı Seçin</option>
                {users.map(u => <option key={u.id} value={u.id}>{u.name || u.email} ({u.email})</option>)}
              </select>
            </div>
          )}
          {couponForm.targetType === 'category' && (
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Kategori</label>
              <select style={inputStyle} value={couponForm.targetCategory} onChange={e => setCouponForm(p => ({ ...p, targetCategory: e.target.value }))}>
                <option value="">Kategori Seçin</option>
                {categories.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
              </select>
            </div>
          )}
          {couponForm.targetType === 'product' && (
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Ürün</label>
              <select style={inputStyle} value={couponForm.targetProductId} onChange={e => setCouponForm(p => ({ ...p, targetProductId: e.target.value }))}>
                <option value="">Ürün Seçin</option>
                {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px' }}>
              <input type="checkbox" checked={couponForm.isActive} onChange={e => setCouponForm(p => ({ ...p, isActive: e.target.checked }))} />
              Aktif
            </label>
          </div>
        </div>

        {couponForm.discountValue && (
          <div style={{ marginTop: '16px', padding: '14px', backgroundColor: '#F6EEDB', borderRadius: '8px', border: '1px solid #ffcdd2' }}>
            <div style={{ fontSize: '12px', color: '#111', marginBottom: '6px', fontWeight: '600' }}>ÖNİZLEME</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ backgroundColor: '#1F4A33', color: 'white', borderRadius: '8px', padding: '10px 16px', fontWeight: '700', fontSize: '18px' }}>
                {couponForm.discountType === 'percent' ? `%${couponForm.discountValue}` : `${couponForm.discountValue} TL`}
              </div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '14px' }}>{couponForm.description || 'Açıklama girilmedi'}</div>
                <div style={{ fontSize: '12px', color: '#111', marginTop: '2px' }}>
                  Kişi başı {couponForm.usagePerUser || 1}x kullanım •{couponForm.minOrderAmount > 0 ? ` Min. ${couponForm.minOrderAmount} TL` : ' Min. tutar yok'}
                </div>
              </div>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          {editingCoupon && onDelete && (
            <button type="button" className="k-btn k-btn-danger" style={{ height: '40px', marginRight: 'auto' }} onClick={onDelete}>Kuponu kaldır</button>
          )}
          <button onClick={onClose} style={cancelBtn}>İptal</button>
          <button onClick={onSave} style={redBtn}>Kaydet</button>
        </div>
      </div>
    </div>
  );
}

export default CouponFormModal;
